import { ListPharmacyPayload, ListPharmacyReturn, getPharmacyPayload, PharmacyInfo } from "@/api/types";
import { baseApi } from "./base";

const pharmacyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPharmacy: builder.mutation<PharmacyInfo, getPharmacyPayload>({
      query: (payload) => {
        return {
          url: "/pharmacy/get",
          method: "POST",
          body: payload,
        };
      },
    }),
    listPharmacy: builder.mutation<ListPharmacyReturn, ListPharmacyPayload>({
      query: (payload) => {
        return {
          url: "/pharmacy/list",
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useListPharmacyMutation, useGetPharmacyMutation } = pharmacyApi;
